import { NotionImportWizard } from '@/components/import/NotionImportWizard.web';

export default function NotionImportSettingsScreen() {
  return <NotionImportWizard />;
}
